import { useState } from 'react'

import { isEmptyHtml } from '@snootsvet/shared'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/frontend/components/ui/dialog'
import { RichTextEditor } from '@/frontend/components/ui/rich-text-editor'

export function InternalNotesDialog({
  value,
  onClose,
  onSave,
  isSaving,
  error,
}: {
  value: string | null
  onClose: () => void
  onSave: (notes: string | null) => void
  isSaving: boolean
  error: Error | null
}) {
  const [draft, setDraft] = useState(value ?? '')

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      disablePointerDismissal
    >
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{isEmptyHtml(value) ? 'Add' : 'Edit'} Internal Notes</DialogTitle>
        </DialogHeader>
        <RichTextEditor
          value={draft}
          onChange={setDraft}
          placeholder="Add internal notes…"
          onCancel={onClose}
          onSave={() => onSave(isEmptyHtml(draft) ? null : draft)}
          isSaving={isSaving}
        />
        {error && (
          <p className="text-sm text-destructive-fg" role="alert">
            {error.message}
          </p>
        )}
      </DialogContent>
    </Dialog>
  )
}
